<template>
    <div class="login-container" style="display: flex; flex-direction: row; height: 100vh;">
        <div class="logo_left">
            <img class="logo" src="@/assets/login/icps_login.png" />
        </div>
        <div class="login_right">
            <gpc-login ref="loginRef" :loading="loading" :loadingVerify="loadingVerify" :loadingRest="loadingRest"
                :systemTitle="systemTitle" :subtitle="SystemDet" :orgTitle="SystemCompany" :promptTitle="SystemMark"
                :icpNo="SystemICP" :waNo="SystemFA" @getCodeRequest="getCodeRequestFun"
                @applySMSCodeRequest="applySMSCodeRequestFun" @applyAccountLoginRequest="applyAccountLoginRequestFun"
                @getVerifyCodeLoginRequest="getVerifyCodeLoginRequestFun"
                @getRegisterPwRequest="getRegisterPwRequestFun"></gpc-login>
        </div>
    </div>
</template>

<script>
import { getPermission, addLoginCode, sendSmsCode, restUserPassword } from "@/api/api";
import { getSystemDetails } from "@/api/common";
import { setPerMission } from "@/utils/auth";
import { GetQueryString } from "@/utils/utils";
import { SystemId, SystemName, SystemDet, SystemMark, SystemICP, SystemFA, SystemCompany, } from "@/common/system";

// import Vcode from "vue-puzzle-vcode";

export default {
    // components: {
    //   Vcode,
    // },
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入用户名"));
            } else {
                callback();
            }
        };
        const validatePassword = (rule, value, callback) => {
            if (value.length < 6) {
                callback(new Error("密码不能少于6位数"));
            } else {
                callback();
            }
        };
        return {
            systemTitle: SystemName,
            SystemDet: SystemDet,
            SystemCompany: SystemCompany,
            SystemMark: SystemMark,
            SystemICP: SystemICP,
            SystemFA: SystemFA,
            loginForm: {
                username: "",
                password: "",
                authCode: "",
            },
            loginRules: {
                username: [{ required: true, trigger: "blur", validator: validateUsername }],
                password: [{ required: true, trigger: "blur", validator: validatePassword }],
            },
            loading: false,
            otherQuery: {},
            redirect: undefined,
            isAndroid: false,
            isiOS: false,
            isShow: false,
        };
    },
    watch: {
        $route: {
            handler: function (route) {
                const query = route.query;
                if (query) {
                    this.redirect = query.redirect;
                    this.otherQuery = this.getOtherQuery(query);
                }
            },
            immediate: true,
            beforeUrl: "",
        },
    },
    computed: {
        istyle() {
            return "font-size: 20px;padding: 14px 10px 0 10px;";
        },
    },
    mounted() {
        const u = navigator.userAgent;
        this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
        this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let params = GetQueryString();
        console.log(params);
        if (params.state && params.state === "login") {
            // 微信登录，查找token
            let code = params.code;
            console.log(code);
            if (code) {
                this.$store
                    .dispatch("user/wxlogin", { type: 1, code: code })
                    .then(res => {
                        if (res && res.code === 1001) {
                            this.getAuth();
                        } else {
                            this.loading = false;
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.beforeUrl = from.path;
        });
    },
    /**  销毁enter事件*/
    methods: {
        applySMSCodeRequestFun(val) {
            console.log("发送短信验证码", val)
            if (!this.$regExp.landlinePhoneReg(val.phoneNum)) {
                this.$message({ type: "error", message: "手机号格式错误！" });
                return
            }
            val.appCode = "ICPS"
            sendSmsCode(val).then((res) => {
                if (res.code == 1001) {
                    this.$message({ type: "success", message: "短信验证码发送成功！" });
                }
            })
        },
        getVerifyCodeLoginRequestFun(val) {
            console.log("验证码登录", val)
            if (!this.$regExp.landlinePhoneReg(val.phoneNum)) {
                this.$message({ type: "error", message: "手机号格式错误！" });
                return
            }
            this.loadingVerify = true
            val.systemId = SystemId
            this.setUserLogin("user/smsLogin", val);
        },
        getRegisterPwRequestFun(val) {
            console.log("重置密码", val)
            if (!this.$regExp.landlinePhoneReg(val.phoneNum)) {
                this.$message({ type: "error", message: "手机号格式错误！" });
                return
            }
            this.loadingRest = true
            val.systemId = SystemId
            restUserPassword(val).then((res) => {
                if (res.code == 1001) {
                    this.$message({ type: "success", message: "密码已重置成功, 请前往登录！" });
                    this.$refs.loginRef.resetPwNotice()
                }
            }).finally(() => {
                this.loadingRest = false
            })

        },
        getCodeRequestFun(type) {
            addLoginCode().then((res) => {
                if (res.code == 1001) {
                    let authCode = res.data;
                    this.$refs.loginRef.getCodeRequest(type, authCode)
                }
            }).catch(() => {
                this.$message({ type: "warning", message: "滑块验证码获取失败，请刷新页面!" });
            });

        },
        applyAccountLoginRequestFun(val) {
            this.loginForm.username = val.username;
            this.loginForm.password = val.password;
            this.loginForm.authCode = val.authCode;
            this.handleLogin()
        },
        submit() {
            this.isShow = true;
        },
        onSuccess() {
            addLoginCode().then(res => {
                if (res.code == 1001) {
                    this.loginForm.authCode = res.data;
                    this.isShow = false; // 通过验证后，关闭模态框
                }
            });
        },

        onClose() {
            this.isShow = false;
        },
        login(type) {
            let redirect_uri = encodeURIComponent("https://lvshe.huashijc.com/#/login"),
                url = "https://open.weixin.qq.com/connect/qrconnect?appid=wx71e02854861febfc&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_login&state=login#wechat_redirect";
            switch (type) {
                case "wechat":
                    window.open(url);
                    break;
                default:
                    break;
            }
        },
        // 账号/密码登录
        handleLogin() {
            this.loading = true;
            this.setUserLogin("user/login", this.loginForm);
        },
        setUserLogin(type, val) {
            this.$store
                .dispatch(type, val)
                .then((res) => {
                    if (res && res.code === 1001) {
                        this.getAuth();
                    }
                })
                .catch(error => {
                    console.log(' --error-- ', error)
                })
                .finally(() => {
                    this.loading = false;
                    this.loadingVerify = false
                    this.loadingRest = false
                });
        },
        /**
         * 获取用户权限
         * by rogerwei 220109
         */
        getAuth() {
            getPermission().then(res => {
                if (res && res.code === 1001) {
                    setPerMission(res.data);
                    getSystemDetails({ code: "watermark" }).then(ress => {
                        if (ress.code === 1001) {
                            window.sessionStorage.setItem("watermark", ress.data.paramValue);
                            this.beforeUrl = '/'
                            this.$router.push({
                                path: document.referrer || this.beforeUrl === "/" ? "/lvshe/index" : this.beforeUrl || "/lvshe/index",
                                query: {
                                    token: window.localStorage.getItem("access-token"),
                                    ...this.otherQuery,
                                },
                            });
                        }
                    });
                }
            });
        },
        getOtherQuery(query) {
            return Object.keys(query).reduce((acc, cur) => {
                if (cur !== "redirect") {
                    acc[cur] = query[cur];
                }
                return acc;
            }, {});
        },
    },
};
</script>

<style lang="scss" scoped>
.login-container {
    position: relative;
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;

    .logo {
        position: absolute;
        left: 1.9%;
        top: 2.6%;
        width: 10.3%;
        height: auto;
    }

    .logo_left {
        height: 100%;
        width: 70%; // background: url(../assets/login/login.png) no-repeat;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8)), url('https://www.huashijc.com/group1/M00/06/B9/ChQACmQdCNOAABmhAAyKNEkcosA364.jpg') center/cover no-repeat;
        background-size: cover;
        background-position: center;
    }

    .login_right {
        background: #ffffff;
        position: relative;
    }
}

.login-container {
    .el-input__inner {
        border-radius: 24px;
        line-height: 48px !important;
        height: 48px !important;
    }

    .el-input--prefix .el-input__inner {
        padding-left: 46px;
    }

    .el-button {
        height: 48px !important;
        width: 100%;
        background: #028037;
    }

    .VcodeButton {
        background: #ffffff !important;
        color: #606266;
        border: 1px solid #dcdfe6;
    }

    .VcodeButton:hover {
        background: #cbf2de !important;
        color: #00b85c;
        border: 1px solid #00b85c;
    }
}
</style>

<style lang="scss" scoped>
.login_bg {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: calc(100vh - 141px);
    padding: 0 132px;

    .login {
        width: 456px;
        height: 540px;
        background: #ffffff;
        padding: 57px;

        .title {
            text-align: center;
        }

        .forget {
            line-height: 19px;
            font-size: 14px;
            color: #999999;
        }

        .input {
            display: flex;
            justify-content: space-between;
            padding-top: 24px;

            input {
                height: 48px;
            }
        }
    }
}
</style>

<style scoped></style>